/**
 *
 * ReportHeader
 *
 */
import React, { Fragment } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { includes, isEqual, filter } from "lodash"
import { Link } from "react-router-dom"
import { Button, Select, Tooltip, Skeleton } from "antd"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import reducer from "./reducer"
import xIcon from "../../../images/x.svg"
import saga from "./saga"
import {
  makeSelectIsEmptyMeditions,
  makeSelectLoadingMeditions,
  makeSelectMeditions,
  makeSelectOfficialize,
  makeSelectOfficializeLoading,
  makeSelectAllMeditions,
  makeSelectAmbassadorCount,
  makeSelectMeditionAvailableActions,
} from "./selectors"
import "./index.less"
import {
  getMeditionsWatcher,
  officializeWatcher,
  setCurrentMedition,
  getMeditionsAvailableActionsWatcher,
  getMeditionsAvailableActionsFailed,
} from "./actions"
import ModalActionPlanCreate from "components/ModalActionPlanCreate"
import ModalOfficializationOfResults from "./components/ModalOfficializationOfResults/index"
import { requestUpgradeApi } from "services/requestUpgrade"
import { DownloadOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import {
  isModeInModuleBySlug,
  isModuleBySlug,
  LOCAL_ANONYMITY,
  LOCAL_ANONYMITY_LEADERS,
} from "../../../utils/storage"
import {
  DISABLE,
  EXPORTABLES,
  OVERALL_RESULTS,
  ACTION_PLANS,
  AMBASSADOR_USERS,
  MEASURE_STATUS,
} from "../../../utils/constants"
import ModalFreemium from "./components/ModalFreemium"
import { validate } from "../../../utils/functions"
import { loadTexts } from "../../../utils/i18n"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class ReportHeader extends React.Component {
  intlHeader = loadTexts("reports_general_view").header
  state = {
    view_leader: false,
    showAlert: false,
    current: {},
    modalOfficialize: false,
    showLastProccess: false,
    nameView: null,
    modalActionPlanCreate: false,
    modalFreemium: false,
  }

  componentWillUnmount = () => {
    this.unlisten()
  }

  componentDidMount() {
    const searchLocation = getUrlParams(location.search)
    const segment =
      searchLocation && validate.exist(searchLocation.id_segment)
        ? searchLocation.id_segment
        : ""
    // Reset buttons actions
    this.props.getAvailableActionsFailed()
    this.props.getMeditions({
      measure: this.props.measure,
      history: this.props.history,
      id_segment: segment,
    })
    this.unlisten = this.props.history.listen((location) => {
      if (location.pathname === "/reports" && this.props.measure) {
        this.props.getMeditions({
          measure: undefined,
          history: this.props.history,
          id_segment: segment,
        })
      }
    })
  }

  getNamePage(url) {
    let names = ["division", "analysis-comparative", "question", "dimensions"]
    let findPage = -1
    names.map((page) => {
      if (includes(url, page)) {
        findPage = page
      }
    })
    if (findPage !== -1) {
      this.setState({ nameView: findPage })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.getNamePage(this.props.match.url)
    let current = nextProps.meditions.filter(
      (e) => e.id_measure == this.props.measure
    )
    if (!isEqual(this.props.meditions, nextProps.meditions)) {
      if (current.length > 0) {
        let anonimate_count = parseInt(
          current[0].id_survey_type === 2
            ? LOCAL_ANONYMITY_LEADERS()
            : LOCAL_ANONYMITY(),
          10
        )
        this.props.setCurrentMeditionWatcher(current[0])
        this.setState(
          {
            current: current[0],
            view_leader: current[0].id_survey_type === 2,
            showAlert: current[0].engagement_is_only
              ? current[0].employees_engagement < anonimate_count
              : current[0].employees_processed < anonimate_count,
          },
          () =>
            this.setState({
              showLastProccess: !this.state.showAlert,
            })
        )

        if (this.props.history.location.search === "?officialized=true") {
          this.setState({
            modalOfficialize: current[0].officialized === 0,
          })
        }
      }
    }
    if (
      this.props.officialize_loading != nextProps.officialize_loading &&
      nextProps.officialize_loading === false
    ) {
      nextProps.meditions.map((e) => {
        if (e.id_measure == this.props.measure) {
          e.officialized = 1
        }
      })
      this.setState(
        {
          modalOfficialize: false,
        },
        () => {
          const searchLocation = getUrlParams(
            this.props.history.location.search
          )
          this.props.getAvailableActions({
            measure_id: this.props.measure,
            id_division: searchLocation
              ? parseInt(searchLocation.id_division)
              : null,
          })
        }
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.measure != this.props.measure) {
      let current = this.props.meditions.filter(
        (e) => e.id_measure == this.props.measure
      )
      if (current.length > 0) {
        let anonimate_count = parseInt(
          current[0].id_survey_type === 2
            ? LOCAL_ANONYMITY_LEADERS()
            : LOCAL_ANONYMITY(),
          10
        )
        this.props.setCurrentMeditionWatcher(current[0])
        this.setState(
          {
            current: current[0],
            view_leader: current[0].id_survey_type === 2,
            showAlert: current[0].engagement_is_only
              ? current[0].employees_engagement < anonimate_count
              : current[0].employees_processed < anonimate_count,
          },
          () => {
            this.setState({
              showLastProccess: !this.state.showAlert,
            })
          }
        )
      }
    }
  }

  hasSelectMeditions = () => {
    if (validRole({ role: [5] })) {
      return filter(
        this.props.all_meditions,
        ({ id_survey_type }) => id_survey_type !== 2
      ).length
    }

    return this.props.all_meditions.length
  }

  renderSkeletonLoading = () => {
    const { loading_meditions } = this.props

    if (!loading_meditions) {
      return null
    }
    return (
      <div
        style={{
          margin: "10px 2rem 0",
          paddingTop: 5,
          height: 38,
          display: "grid",
          gridGap: 100,
          gridTemplateColumns: "2fr 600px",
        }}>
        <Skeleton active title={{ width: "100%" }} paragraph={{ rows: 0 }} />
        <Skeleton active title={{ width: "100%" }} paragraph={{ rows: 0 }} />
      </div>
    )
  }

  renderModalFreemium = () => {
    const isFreemium = window.freemium()
    if (!isFreemium) {
      return null
    }
    const { modalFreemium } = this.state
    return (
      <ModalFreemium
        handleOk={() => {
          requestUpgradeApi()
          this.setState({
            modalFreemium: false,
          })
        }}
        handleCancel={() => this.setState({ modalFreemium: false })}
        isVisible={modalFreemium}
      />
    )
  }

  renderButtonOfficialize = () => {
    const { available_actions, officialize_loading } = this.props
    if (!available_actions.is_officializable) {
      return null
    }
    return (
      <Button
        loading={officialize_loading}
        type="primary"
        onClick={() => this.setState({ modalOfficialize: true })}>
        Oficializar resultados
      </Button>
    )
  }

  renderButtonExportable = () => {
    const { available_actions } = this.props
    const isExportable = isModeInModuleBySlug(EXPORTABLES) !== DISABLE
    if (!available_actions.is_exportable || !isExportable) {
      return null
    }
    const isFreemium = window.freemium()
    if (isFreemium) {
      return (
        <Button
          type="primary"
          onClick={() => this.setState({ modalFreemium: true })}>
          Generar reporte
        </Button>
      )
    }
    return (
      <Link
        className="ant-btn ant-btn-primary"
        to={`/reports/export/measure/${this.props.measure}`}
        onClick={() => woopraTrack("Generar reporte")}>
        Generar reporte
      </Link>
    )
  }

  renderButtonActionPlan = () => {
    const { available_actions } = this.props
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    if (!isActionPlans || !available_actions.is_action_plan_creatable) {
      return null
    }
    return (
      <Button
        type="primary"
        style={{ marginRight: 9 }}
        onClick={() => {
          woopraTrack("Crear plan de acción")
          this.setState({ modalActionPlanCreate: true })
        }}>
        Crear plan de acción
      </Button>
    )
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  renderAlertContent = () => {
    const { showAlert, view_leader } = this.state
    if (!showAlert) {
      return null
    }
    let anonimate_count = parseInt(
      view_leader ? LOCAL_ANONYMITY_LEADERS() : LOCAL_ANONYMITY(),
      10
    )
    return (
      <div className="measurement-details-alert">
        <span>
          Recuerda que la información irá apareciendo conforme las respuestas
          superen el <strong>mínimo de anonimato</strong> definido en el panel
          de control de{" "}
          <strong>
            {anonimate_count} respuestas por{" "}
            {view_leader ? "equipo" : "división"}
          </strong>
          .
        </span>
        <img src={xIcon} onClick={() => this.setState({ showAlert: false })} />
      </div>
    )
  }

  renderHeaderContent = () => {
    const { visibleHeader } = this.props
    if (!visibleHeader) {
      return null
    }
    const isOverallResults = isModuleBySlug(OVERALL_RESULTS)
    return (
      <Fragment>
        <div
          key="title-ReportHeader"
          className="ReportHeader-title title_section">
          <span>{this.intlHeader.menuOptions.reports}</span>
        </div>
        <div key="ReportHeader-tabs" className="ReportHeader-tabs">
          {isOverallResults && (
            <span className="ReportHeader-tabs-item active">
              {this.intlHeader.labelMeasures}
            </span>
          )}
        </div>
        {isOverallResults && (
          <div key="ReportHeader-buttons" className="ReportHeader-buttons">
            {this.renderButtonActionPlan()}
            {this.renderButtonExportable()}
            {this.renderButtonOfficialize()}
          </div>
        )}
      </Fragment>
    )
  }

  renderIconExportReport = () => {
    const { showDownload, available_actions, measure } = this.props
    const { nameView } = this.state
    if (!available_actions.is_exportable || !showDownload) {
      return null
    }
    const isFreemium = window.freemium()
    let iconExportReport = (
      <Link
        style={{
          height: 30,
          borderRadius: 1,
          padding: "0 9px",
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
          borderWidth: 0,
        }}
        className="ant-btn"
        to={`/reports/export/measure/${measure}${nameView !== null &&
          `/${nameView}`}`}>
        <DownloadOutlined
          style={{ verticalAlign: "baseline", color: "#1890ff" }}
          twoToneColor="#1890ff"
        />
      </Link>
    )
    if (isFreemium) {
      iconExportReport = (
        <span
          style={{
            height: 30,
            borderRadius: 1,
            padding: "0 9px",
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
            borderWidth: 0,
          }}
          className="ant-btn"
          onClick={() => this.setState({ modalFreemium: true })}>
          <DownloadOutlined
            style={{ verticalAlign: "sub", color: "#1890ff" }}
            twoToneColor="#1890ff"
          />
        </span>
      )
    }
    return (
      <div style={{ textAlign: "right" }}>
        {iconExportReport}
        <div />
      </div>
    )
  }

  renderMeditionContent = () => {
    const {
      showDownload,
      isHome,
      hideMeditions,
      blankMeditionSelector,
      meditions,
      is_empty_meditions,
      rightWidth,
      available_actions,
      match,
      history,
    } = this.props
    const { current, showLastProccess } = this.state
    const isOverallResults = isModuleBySlug(OVERALL_RESULTS)
    if (hideMeditions || is_empty_meditions || !isOverallResults) {
      return <div style={{ height: 30 }} />
    }
    let styleHeaderMedition = {
      gridTemplateColumns: `90px auto ${rightWidth}`,
      gridGap: 10,
    }
    if (!available_actions.is_exportable || !showDownload) {
      styleHeaderMedition = {
        gridTemplateColumns:
          showLastProccess &&
          current.date_processed &&
          current.employees_processed
            ? this.hasSelectMeditions() > 1
              ? "100px auto 630px"
              : "100px auto 380px"
            : "100px auto 245px",
      }
    }
    const measureInProgress = MEASURE_STATUS.in_progress
    return (
      <div className="ReportHeader-meditions" style={styleHeaderMedition}>
        <span className="ReportHeader-meditions-title">
          {this.intlHeader.labelMeasures}
        </span>

        {Array.isArray(meditions) && (
          <Select
            placeholder="Seleccionar medición"
            style={{ width: 250 }}
            onChange={(e) => history.push(`/reports/measure/${e}`)}
            value={
              blankMeditionSelector ? undefined : Number(match.params.id)
            }>
            {Array.isArray(meditions) &&
              meditions.map((e) => {
                return (
                  <Option
                    key={e.id_measure}
                    value={e.id_measure}
                    className={
                      e.id_measure_status ===
                      measureInProgress.id_measure_status
                        ? "ReportHeader-meditions-current"
                        : ""
                    }>
                    <Tooltip
                      placement="leftTop"
                      title={e.name}
                      align={{
                        offset: [-8, -6],
                      }}>
                      {e.name}
                    </Tooltip>
                  </Option>
                )
              })}
          </Select>
        )}

        {isHome && (
          <div className="ReportHeader-select-meditions">
            {showLastProccess &&
              current.date_processed &&
              current.employees_processed && (
                <span>
                  Último reprocesamiento de métricas: {current.date_processed}
                </span>
              )}
          </div>
        )}

        {this.renderIconExportReport()}
      </div>
    )
  }

  render() {
    const {
      officialize_loading,
      ambassador_count,
      officializeWatcher,
      measure,
    } = this.props
    const { view_leader, modalOfficialize, modalActionPlanCreate } = this.state
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    return (
      <div className="ReportHeader">
        {this.renderAlertContent()}
        {this.renderHeaderContent()}
        {this.renderSkeletonLoading()}
        {this.renderMeditionContent()}

        <ModalActionPlanCreate
          visible={modalActionPlanCreate}
          onCancel={() => this.setState({ modalActionPlanCreate: false })}
        />

        <ModalOfficializationOfResults
          measure={measure}
          isLoading={officialize_loading}
          isVisible={modalOfficialize}
          onCancel={() => this.setState({ modalOfficialize: false })}
          officializeWatcher={officializeWatcher}
          isAmbassador={isAmbassador && !view_leader && ambassador_count > 0}
        />

        {this.renderModalFreemium()}
      </div>
    )
  }
}

ReportHeader.defaultProps = {
  rightWidth: "46px",
}

const mapStateToProps = createStructuredSelector({
  is_empty_meditions: makeSelectIsEmptyMeditions(),
  loading_meditions: makeSelectLoadingMeditions(),
  meditions: makeSelectMeditions(),
  officialize: makeSelectOfficialize(),
  officialize_loading: makeSelectOfficializeLoading(),
  all_meditions: makeSelectAllMeditions(),
  ambassador_count: makeSelectAmbassadorCount(),
  available_actions: makeSelectMeditionAvailableActions(),
})

function mapDispatchToProps(dispatch) {
  return {
    getMeditions: (params) => dispatch(getMeditionsWatcher(params)),
    officializeWatcher: (params) => dispatch(officializeWatcher(params)),
    setCurrentMeditionWatcher: (params) => dispatch(setCurrentMedition(params)),
    getAvailableActions: (params) =>
      dispatch(getMeditionsAvailableActionsWatcher(params)),
    getAvailableActionsFailed: () =>
      dispatch(getMeditionsAvailableActionsFailed()),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "reportHeader", reducer })
const withSaga = injectSaga({ key: "reportHeader", saga })

export default compose(withReducer, withSaga, withConnect)(ReportHeader)
